<template>
	<div class="logo-box" :style="is_phone ? 'padding: .5rem 20px;' : 'padding: 1.43rem 12% 1.43rem 12%;'">
		<div class="big-title">{{$store.state.language == 'EN' ? 'cooperative partner':'合作伙伴'}}</div>
		<div class="pc-box">
			<div v-if="is_phone" style="display: flex;flex-wrap: wrap;justify-content: center;">
				<div
					v-for="(val, ind) in phone_list"
					:key="ind"
					:style="`animation-duration: ${val.duration}s;animation-delay: ${val.delay}s;width:${val.w}rem;height:${val.w}rem;${val.margin}`"
					class="item"
				>
					<img :src="val.logo" alt="" />
				</div>
			</div>
			<div v-else>
				<div class="flex-cs" v-for="(v, i) in pc_list" :key="i">
					<div
						v-for="(val, ind) in v"
						:key="ind"
						:style="`animation-duration: ${val.duration}s;animation-delay: ${val.delay}s;width:${val.w}rem;height:${val.w}rem;${val.margin}`"
						class="item"
					>
						<img :src="val.logo" alt="" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: '',
	data() {
		return {
			pc_list: [],
			phone_list:[],
		};
	},
	created() {
		let rand = num => {
			return Number((Math.random() * num).toFixed(2));
		};
		this.$get({
			url: 'app/getCustomer',
			success: res => {
				let logo_list = res.list;
				for (let i in logo_list) {
					logo_list[i].w = rand(1) + 0.8;
					logo_list[i].duration = 1 + rand();
					logo_list[i].delay = rand(2);
					logo_list[i].margin = `margin:${rand(0.2) + 0.1}rem ${rand(0.2) + 0.2}rem ${rand(0.2) + 0.1}rem ${rand(0.2) + 0.1}rem;`;
				}
				let list = [];
				for (let i = 0; i < logo_list.length - 1; i += 6) {
					list.push(logo_list.slice(i, i + 6));
				};
				this.pc_list = list;
				this.phone_list = logo_list;
			}
		});
	},
	methods: {}
};
</script>

<style scoped="scoped">
/* PC */
.pc-box {
	background-image: url(https://imgtest.togy.com.cn/oyjj/langGuo/home_cbg.png);
	background-size: cover;
}
.logo-box {
}
.item {
	display: inline-block;
	box-shadow: 0px 0.1rem 0.2rem 0.05rem rgba(0, 0, 0, 0.1);
	padding: 0.2rem;
	border-radius: 50%;
	background-color: #ffffff;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	animation-name: logo2;
	animation-duration: 2s;
	animation-timing-function: ease-in-out;
	animation-iteration-count: infinite;
	animation-direction: alternate;
	overflow: hidden;
}
img {
	width: 100%;
	height: auto;
}
@keyframes logo2 {
	0% {
		transform: translateY(0px);
	}
	100% {
		transform: translateY(10px);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/logo.vue